import styled from 'styled-components';
import { rem } from '../../utils';
export const Video = styled.video `
  clip-path: ${({ crop }) => crop ? `inset(${rem(crop)} ${rem(crop)})` : `inset(0)`};
  object-fit: ${({ objectFit }) => objectFit || 'cover'};
  width: 100%;
  width: 100%;
  z-index: 0;
`;
//# sourceMappingURL=VideoPlayer.style.js.map